import React from 'react';

import PropTypes from 'prop-types';
import './style.scss';
import { useTranslation } from 'react-i18next';

const ThreePositionSwitcher = ({ positions = [], selected, setSelected }) => {
  const { t } = useTranslation('');

  return (
    <div className="switcher-wrapper">
      {positions.map((position) => (
        <div
          className={`switcher-button ${selected === position ? 'selected' : ''}`}
          style={{
            cursor: 'pointer',
          }}
          key={position}
          onClick={() => setSelected(position)}
        >
          {t(position)}
        </div>
      ))}
    </div>
  );
};

export default ThreePositionSwitcher;

ThreePositionSwitcher.propTypes = {
  positions: PropTypes.array,
  selected: PropTypes.string,
  setSelected: PropTypes.func,
};
